import { createGlobalStyle } from "styled-components";

const CustomStyle = createGlobalStyle`
& input {
    -webkit-appearance: none;
    -webkit-border-radius:0; 
    border-radius:0;
}
`;

export default CustomStyle;
